/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export enum OrderStatusEnum {
  sent = 'sent',
  accepted = 'accepted',
  rejected = 'rejected',
  in_progress = 'in_progress',
  in_transit = 'in_transit',
  completed = 'completed',
  archived = 'archived',
  cancelled = 'cancelled',
}
